import React from 'react';
import './style.css'
import InformationForm from '../InformationForm';

const InformationPage = () => {
    return (
        <div id="Contact" className="contact-area">
            <div className="container">
                <div className="contact-form">
                    <InformationForm />
                </div>
            </div>
        </div>
    )
}

export default InformationPage;